<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Historique de EITP" />
            <QuiSommesNouss/>
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import FooterComp from '../Layouts/FooterComp'
import QuiSommesNouss from './QuiSommesNouss.vue'



export default {
    name: 'SecretariatPage',
    components: {
        NavBar,
        PageTitle,
        QuiSommesNouss,
        FooterComp,
    }
}
</script>